export { USER_HOOK_NAMES } from './plugins/hooks.js';
export type { PluginsInterface } from './plugins/plugins-interface.js';
export { createPluginsInterface } from './plugins/plugins-interface.js';
export type * from './types/wix-astro-config.js';
export { importWixConfig } from './import-config.js';
export {
  getExistingWixConfigPaths,
  validateWixConfig,
  defineWixConfig,
} from './wix-config.js';
export { parseStdErr } from './parse-stderr.js';
export type { CliErrorCtx } from './plugins/events.js';
